import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=5ed41b14&scoped=true&"
import script from "./FooterComponent.vue?vue&type=script&lang=js&"
export * from "./FooterComponent.vue?vue&type=script&lang=js&"
import style0 from "./FooterComponent.vue?vue&type=style&index=0&id=5ed41b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed41b14",
  null
  
)

component.options.__file = "FooterComponent.vue"
export default component.exports